var _rect, _path, _rect2, _path2, _rect3, _path3, _path4, _rect4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 33,
    viewBox: "0 0 103 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.3076,
    y: 4.44043,
    width: 22.7692,
    height: 22.7692,
    fill: "#1EB65B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.6923 14.9785L67.7559 27.9016H59.6286L63.6923 14.9785Z",
    fill: "#FBFBFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76.3843,
    y: 4.44043,
    width: 22.7692,
    height: 22.7692,
    fill: "#1EB65B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6152 18.5944L99.1537 13.7979L99.1537 23.3908L87.6152 18.5944Z",
    fill: "#FBFBFB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.231,
    y: 4.44043,
    width: 22.7692,
    height: 22.7692,
    fill: "#1EB65B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0771 20.9786L49.0002 16.915L49.0002 25.0422L36.0771 20.9786Z",
    fill: "#FBFBFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0771 11.2862L49.0002 7.22257L49.0002 15.3499L36.0771 11.2862Z",
    fill: "#FBFBFB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 27.21,
    width: 22.7692,
    height: 23.7692,
    transform: "rotate(-90 0 27.21)",
    fill: "#1EB65B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.001L13.6029 4.25098L21.3971 4.25098L17.5 17.001Z",
    fill: "#FBFBFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.001L3.60289 4.25098L11.3971 4.25098L7.5 17.001Z",
    fill: "#FBFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bbb342b58c59acb240c55b538ce2912d.svg";
export { ForwardRef as ReactComponent };